var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoCaution = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 40,
  fill: "none",
  viewBox: "0 0 50 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3.717 35.94 23.304 4.6a2 2 0 0 1 3.392 0l19.587 31.34c.833 1.332-.125 3.06-1.696 3.06H5.413c-1.571 0-2.529-1.728-1.696-3.06Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00AED9",
  d: "M24.631 26.987h.747c.21 0 .42-.187.443-.374l.91-6.556v-2.614a.46.46 0 0 0-.443-.443h-2.567a.46.46 0 0 0-.443.443v2.66l.91 6.51c.023.187.233.374.443.374m-1.54 4.666c0 1.05.864 1.914 1.89 1.914a1.927 1.927 0 0 0 1.937-1.914c0-1.05-.863-1.936-1.937-1.936-1.026 0-1.89.886-1.89 1.936"
})));
export default SvgIcoCaution;